export default class mailEditorWrapper {
    constructor() {
        return {
            template: require('../../../../views/maileditor/editor-wrapper.html'),
            restrict: 'E',
            scope: {
              type: '@'
            },
            controller: EditorWrapper,
            controllerAs: 'wrapper'
        }
    }
};

class EditorWrapper {
    constructor($scope, $attrs, $timeout, EditorEventHandler) {
        this._scope = $scope;

        this.dispatcherType = this._scope.type;
        
        this._scope.$on('mailEditor:state:init', (event, data) => {
            this.dispatcherType = data.dispatcherType;
            this.dispatcher = data.dispatcher;

            this._scope.$broadcast('mailEditor:htmlSource', data.htmlSource);
        });
        
        this._scope.$on('mailEditor:segments:fetched', (event, segments) => {
            this.segments = segments;
            EditorEventHandler.segments = segments;
        });

        this._scope.$on('mailEditor:tags:fetched', (event, tags) => {
            this.tags = tags;
            EditorEventHandler.tags = tags;
        });

        this._scope.$on('mailEditor:customizations:fetched', (event, customizations) => {
            this.customizations = customizations;
            EditorEventHandler.customizations = customizations;
        });
        
        this._scope.$on('mailEditor:template:fetched', (event, templateHtml) => {
            this._scope.$broadcast('mailEditor:template:parseTemplate', templateHtml);
        });
        
        this._scope.$on('mailEditor:content:loaded', () => {
            this._scope.$broadcast('mailEditor:content:setLoaded');

            $timeout(() => {
                this._scope.$broadcast('mailEditor:language:get', (language) => {
                    this._scope.$broadcast('mailEditor:language:toggle', language);
                });
            });
        });
        
        this._scope.$on('mailEditor:setLanguage', (event, currentLanguage) => {
            this._scope.$broadcast('mailEditor:language:toggle', currentLanguage);
        });

        this._scope.$on('mailEditor:language:initBlocks', (event, language) => {
            this._scope.$broadcast('mailEditor:language:toggle', language);
        });

        this._scope.$on('mailEditor:historicalHtml', (event, historySource) => {
            this._scope.$broadcast('mailEditor:htmlSource', historySource);
        });

        this._scope.$on('mailEditor:historicalPlain', (event, source) => {
            this._scope.$broadcast('plainContent:fetchHistoricalVersion', source);
        });

        this._scope.$on('element:added', (event, element) => {
            this._scope.$broadcast('mailEditor:element:handleAdded', element);  
        });
        
        this._scope.$on('mailEditor:toggleBlockOverlay', (event, show) => {
            this._scope.$broadcast('mailEditor:blockOverlay:toggle', show);
        });

        this._scope.$on('mailEditor:toggleSettingsOverlay', (event, show) => {
            this._scope.$broadcast('mailEditor:settingsOverlay:toggle', show);
        });
        
        this._scope.$on('mailEditor:settings:linkColorChanged', (event, newColor) => {
            this._scope.$broadcast('mailEditor:settings:setLinkColor', newColor);
        });

        this._scope.$on('mailEditor:settings:linkUnderlineChanged', (event, newChoice) => {
            this._scope.$broadcast('mailEditor:settings:applyLinkUnderlineSettings', newChoice);
        });
        
        this._scope.$on('mailEditor:settings:imageSettingsChanges', (event, imageSetting) => {
            this._scope.$broadcast('mailEditor:settings:applyImageBlockSettings', imageSetting);
        });
        
        this._scope.$on('mailEditor:fetch:tagsAndSegments', (event, callback) => {
            return callback({ tags: this.tags, segments: this.segments });
        });
    }
}